export const COMPANY = {
  name: "JL Service",
  owner: "Johnny Lund Jensen",
  city: "Hammel",
  phone: "61 71 46 48",
  phoneRaw: "+4561714648",
  email: "johnny.lund.jensen@gmail.com",
  facebook:
    "https://web.facebook.com/pages/JL%20service/974498665751063/",
};

export const MEDIA = {
  hero: "https://customer-assets.emergentagent.com/job_jl-woodwork/artifacts/2wi49fns_1.jpg",
  portfolio: [
    "https://customer-assets.emergentagent.com/job_jl-woodwork/artifacts/2wi49fns_1.jpg",
    "https://customer-assets.emergentagent.com/job_jl-woodwork/artifacts/ct6lyyh7_2.jpg",
    "https://customer-assets.emergentagent.com/job_jl-woodwork/artifacts/y2nr0d8h_3.jpg",
    "https://customer-assets.emergentagent.com/job_jl-woodwork/artifacts/qutlbssn_4.jpg",
  ],
  portrait:
    "https://customer-assets.emergentagent.com/job_jl-woodwork/artifacts/ep7q5k5n_johnny%20lund%20jensen.jpg",
};

export const NAV_LINKS = [
  { href: "#services", label: "Ydelser" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#om", label: "Om" },
  { href: "#kontakt", label: "Kontakt" },
];
